export const GET: string = 'get';
export const POST: string = 'post';
export const PATCH: string = 'patch';
export const DELETE: string = 'delete';
